import React, { useState } from 'react';
import { NumericInput } from './NumericInput';
import { getNumericFieldError } from '../utils/numericValidation';

/**
 * NumericInput + on-blur / on-submit validation.
 * Keeps the raw typed string in the parent state so "0", "0." and "0.125" all survive typing.
 */
export const NumericField = ({
  value,
  onChange,
  rules = {},
  showError = false,
  className = '',
  errorTestId,
  onBlur,
  ...props
}) => {
  const [touched, setTouched] = useState(false);
  const error = getNumericFieldError(value, rules);
  const visible = !!error && (touched || showError);

  return (
    <>
      <NumericInput
        {...props}
        allowFraction={!!rules.allowFraction}
        value={value ?? ''}
        onChange={onChange}
        onBlur={(e) => {
          setTouched(true);
          onBlur?.(e);
        }}
        className={`${visible ? 'border-red-500' : ''} ${className}`.trim()}
      />
      {visible && (
        <p className="text-xs text-red-500" data-testid={errorTestId}>{error}</p>
      )}
    </>
  );
};
